import { CE_SCREEN_CLOSE } from "@js/actions/studio/screens.js";

export const CE_VIEW_TEXT_VERSION_OPEN = "CE_VIEW_TEXT_VERSION_OPEN";
export const ceScreenViewTextVersionOpen = (clientContentID) => ({
  type: CE_VIEW_TEXT_VERSION_OPEN,
  client_content_id: clientContentID,
});

export const ceScreenViewTextVersionCancel = () => ({
  type: CE_SCREEN_CLOSE,
});
